import React, { useState, useEffect, useContext } from "react";
import Footer from "../components/dashboard/footer";
import Header from "../components/dashboard/header";
import Sidebar from "../components/dashboard/sidebar";
import { useNavigate, useLocation } from "react-router-dom";
import axios from 'axios';
import tmdbApi from "../api/tmdbApi";
import moment from "moment";
import Modal from 'react-bootstrap/Modal';
import SweetAlert from 'react-bootstrap-sweetalert';
import Loader from "../components/loader";
import { contentContext } from "../context/contentContext";
import SessionPopup from "../pages/SessionPopup"
import TableLoader from "../components/tableLoader";
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import { keyActivate } from "../utils/a11y";

let { lambda, appname } = window.app

// Alert copy is locked server-side: the composer picks an approved template and
// fills its constrained variables, and the backend renders the final message.
// The helpers below only drive the live preview and character counter — the
// server re-validates everything and is the authority on what can be sent.

const OPT_OUT_SUFFIX = ' Reply STOP to opt out.';
const SMS_SEGMENT_LIMIT = 160;

// Caps on the auto-filled brand tokens, mirroring the server.
const BRAND_CAPS = { location_name: 27, company_name: 20 };

// GSM 03.38 basic set. Anything outside it (em dash, curly quotes, emoji) forces
// UCS-2 encoding and cuts the segment limit from 160 to 70.
const GSM7_BASIC = new Set(
  ('@£$¥èéùìòÇ\nØø\rÅå'
  + 'Δ_ΦΓΛΩΠΨΣΘΞÆæßÉ'
  + ' !"#¤%&\'()*+,-./0123456789:;<=>?'
  + '¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§'
  + '¿abcdefghijklmnopqrstuvwxyzäöñüà').split('')
);
// Still GSM-7, but each of these occupies two septets.
const GSM7_EXTENDED = new Set('^{}\\[~]|€'.split(''));

const gsm7Length = (str) => {
  let len = 0;
  for (const ch of String(str || '')) len += GSM7_EXTENDED.has(ch) ? 2 : 1;
  return len;
};

const findNonGsm7 = (str) => {
  const bad = new Set();
  for (const ch of String(str || '')) {
    if (!GSM7_BASIC.has(ch) && !GSM7_EXTENDED.has(ch)) bad.add(ch);
  }
  return [...bad];
};

const DATE_PATTERN = /^[A-Z][a-z]{2} \d{1,2}$/;

// Times are offered as a fixed list so the value always matches the format the
// server accepts ("7:30 PM") — no free typing, no parsing surprises.
const TIME_OPTIONS = (() => {
  const out = [];
  for (let h = 0; h < 24; h++) {
    for (const m of [0, 15, 30, 45]) {
      out.push(`${h % 12 || 12}:${String(m).padStart(2, '0')} ${h >= 12 ? 'PM' : 'AM'}`);
    }
  }
  return out;
})();

const formatShortDate = (date) =>
  date ? moment(date).format('MMM D') : '';

// A when_hybrid value that is a date renders with its prefix ("on Jul 28").
const renderVariableValue = (variable, value) => {
  if (variable.type === 'when_hybrid' && DATE_PATTERN.test(value)) {
    return (variable.datePrefix || '') + value;
  }
  return value;
};

const substitute = (str, values) =>
  Object.entries(values).reduce((out, [key, val]) => out.split(`{${key}}`).join(val), str);

/** Build the preview strings for a template + the values entered so far. */
const renderPreview = (template, values, brand) => {
  if (!template) return null;
  const subs = {};
  Object.entries(BRAND_CAPS).forEach(([token, cap]) => {
    subs[token] = String(brand?.[token] || '').slice(0, cap) || `{${token}}`;
  });
  (template.variables || []).forEach(v => {
    const raw = values?.[v.name];
    subs[v.name] = raw ? renderVariableValue(v, String(raw)) : `{${v.name}}`;
  });

  const title = substitute(template.title, subs);
  const body = substitute(template.body, subs);
  return {
    title,
    body,
    smsBody: body + OPT_OUT_SUFFIX,
    smsLength: gsm7Length(body + OPT_OUT_SUFFIX)
  };
};

const Notification = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { search } = state || {};
  const [toggle, setToggle] = useState(false);
  const [storeData, setStoreData] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [templatesLoading, setTemplatesLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedTemplateId, setSelectedTemplateId] = useState("");
  const [templateVars, setTemplateVars] = useState({});
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState("ALL");
  const [visitorGroups, setVisitorGroups] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [groupsLoading, setGroupsLoading] = useState(false);
  // const [selectedVisitors, setSelectedVisitors] = useState({});
  // const [userdata, setUserData] = useState([]);
  const [errors, setErrors] = useState({});
  const [user, setUser] = useState("");
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    visitor: '',
    visitorId: [],
    scheduleddate: '',
    logo: '',
    promotionid: '',
    status: ''
  });
  const [initialFormData, setInitialFormData] = useState({
    title: '',
    description: '',
    visitor: '',
    visitorId: [],
    scheduleddate: '',
    logo: '',
    promotionid: '',
    status: ''
  });

  const [fileError, setFileError] = useState("");
  const [filesData, setFilesData] = useState([])
  const [fileSizeError, setFileSizeError] = useState(false);
  const [files, setFiles] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [alertConfig, setAlertConfig] = useState({
    title: '',
    type: '',
    message: ''
  });
  const [isDelete, setIsDelete] = useState(false)
  const [btnLoader, setBtnLoader] = useState(false)
  const [deleteLoader, setDeleteLoader] = useState(false)
  const [previewAlert, setPreviewAlert] = useState(null)

  // const [perpage, setPerpage] = useState(10);
  // const [arrow, setArrow] = useState(0);
  const [perpage, setPerpage] = useState(10);
  const [image, setImg] = useState("");
  // const [currentPage, setcurrentPage] = useState(1);
  const [itemsPerPage, setitemsPerPage] = useState(10);

  const [pageNumberLimit, setpageNumberLimit] = useState(5);
  const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
  const [minPageNumberLimit, setminPageNumberLimit] = useState(0);
  const [showSessionPopupup, setShowSessionPopupup] = useState(false);
  const [tableErrMsg, setTableErrMsg] = useState(false);
  const [toastMessage, setToastMessage] = useState(""); // State for dynamic message
  const [promotionid, setpromotionid] = useState("")
  const [toastType, setToastType] = useState("")
  const [arrowdir, setArrowDir] = useState('down');
  const [num, setNum] = useState();
  // const [sortDirection, setSortDirection] = useState('asc');


  const loginType = localStorage.getItem('login_type'); // 'admin' or 'client'
  // // console.log('loginType',loginType,localStorage.getItem("clientid"));
  const useruniqueid = localStorage.getItem("clientid")

  // let id = localStorage.getItem("userId");

  const [flag, setFlag] = useState(false);

  // const [isLoading, setIsLoading] = useState(false); 
  const { searchedFlag, setSearchedFlag, isLoading, setIsLoading, clientInfo, userData, isRefreshed, setIsRefreshed, setUserData, GetClientDataContext, activeMenuObj, setActiveMenuObj, sortTableAlpha, arrow, usersearch, setUserSearch, currentPage, setcurrentPage, data, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, GetTimeActivity } = useContext(contentContext)
  const validateObj = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu === "Alerts")
  const subValDashboard = validateObj && validateObj[0] && validateObj[0].dashboard
  // console.log('validate obj', validateObj)

  const [showDiscardModal, setShowDiscardModal] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);
  const [isResend, setIsResend] = useState(false);
  // const [initialFormData, setInitialFormData] = useState({
  //   title: '',
  //   description: '',
  //   visitor: '',
  //   visitorId: [],
  //   scheduleddate: '',
  //   logo: '',
  //   promotionid: ''
  // });

  const hasFormChanges = () => {
    return JSON.stringify(formData) !== JSON.stringify(initialFormData);
  };
  // console.log("userDatatatatatatattatatata", userData)
  const prevRoute = usePrevious(route)
  useEffect(() => {
    if (prevRoute !== undefined && prevRoute != route) {
      setCurrentPage(1)
      setRowsPerPage(15)
      setSearchedFlag(false);
      setUserSearch("")
    }
  }, [prevRoute]);
  //  // console.log('prevRoute--->',prevRoute)
  //  // console.log('currentRoute--->',route)
  useEffect(() => {
    getAlerts();
    getStores();
    getAlertTemplates();
    getVisitorGroups("ALL");
  }, [])
  useEffect(() => {
    if (toastMessage && toastType && toast[toastType]) {
      toast[toastType](toastMessage, {
        position: "bottom-center",
        // autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      // Clear the message after showing to prevent re-triggering
      setToastMessage && setToastMessage("");
    }
  }, [toastMessage, toastType]);
  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/signin");
      return;
    }

    // Skip if clientInfo is still empty
    if (!clientInfo?.subscriptionPayment) return;

    if (clientInfo.subscriptionPayment !== "PAYMENT SUCCESS") {
      navigate("/signin");
    }
  }, [clientInfo, navigate]);

  useEffect(() => {

    if (window.site === undefined) {
      setTimeout(() => {
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
          setImg(window.site.common.imageCloudfront)
        }
      }, 1000);
    }
    if (window.site && window.site.common && window.site.common.imageCloudfront) {
      setImg(window.site.common.imageCloudfront)
    }


  }, [window.site]);

  // useEffect(() => {
  //   if (formData.visitor === "ALL" && visitorData?.length > 0) {
  //     const allVisitorIds = visitorData.map(v => v.visitorid);
  //     setFormData(prev => ({
  //       ...prev,
  //       visitorId: allVisitorIds
  //     }));
  //   }
  // }, [visitorData]);
  // console.log("formData",formData)
  // const handleEdit = async (data) => {
  //   // setIsLoading(true)
  //   setErrors({})
  //   setFormData(data)
  //   // console.log("datatatataat", data)
  // }
  // const handleEdit = async (data) => {
  //   // If form has unsaved changes, show modal
  //   if (hasFormChanges()) {
  //     setPendingAction(() => () => {
  //       setErrors({});
  //       const editData = {
  //         ...data,
  //         scheduleddate: data.scheduleddate ? new Date(data.scheduleddate) : null
  //       };
  //       setFormData(editData);
  //       setInitialFormData(editData);
  //     });
  //     setShowDiscardModal(true);
  //   } else {
  //     // No changes, proceed directly
  //     setErrors({});
  //     const editData = {
  //       ...data,
  //       scheduleddate: data.scheduleddate ? new Date(data.scheduleddate) : null
  //     };
  //     setFormData(editData);
  //     setInitialFormData(editData);
  //   }
  // };
  const handleEdit = async (data) => {
    const location = data.storeid || "ALL";

    const applyEdit = () => {
      setErrors({});
      const now = new Date();
      const originalDate = data.scheduleddate ? new Date(data.scheduleddate) : null;
      const isInPast = originalDate && originalDate < now;
      const resolvedDate = isInPast ? roundUpTo15Min(now) : originalDate;

      const editData = {
        ...data,
        scheduleddate: resolvedDate
      };
      setFormData(editData);
      setInitialFormData(editData);
      setSelectedLocation(location);
      restoreTemplateSelection(data);
      getVisitorGroups(location, true, data.visitor || "");
      if (isInPast) {
        setToastMessage("The scheduled date/time was in the past and has been reset to now. Please review before saving.");
        setToastType("warning");
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    if (hasFormChanges()) {
      setPendingAction(() => applyEdit);
      setShowDiscardModal(true);
    } else {
      applyEdit();
    }
  };

  const resetForm = () => {
    const emptyForm = {
      title: '',
      description: '',
      visitor: '',
      visitorId: [],
      scheduleddate: '',
      logo: '',
      promotionid: '',
      status: ''
    };
    setFormData(emptyForm);
    setInitialFormData(emptyForm);
    setErrors({});
    setSelectedLocation("ALL");
    getVisitorGroups("ALL");
    setSelectedGroups([]);
    setIsResend(false);
    setSelectedCategory("");
    setSelectedTemplateId("");
    setTemplateVars({});
  };

  /**
   * Reopen a saved alert in the composer. Alerts created before templates
   * shipped have no templateId — their copy can't be reconstructed, so the
   * sender must pick an approved message before saving.
   */
  const restoreTemplateSelection = (data) => {
    const template = templates.find(t => t.id === data?.templateId);
    if (template) {
      setSelectedCategory(template.category);
      setSelectedTemplateId(template.id);
      setTemplateVars(data.templateVariables || {});
    } else {
      setSelectedCategory("");
      setSelectedTemplateId("");
      setTemplateVars({});
      if (data?.title) {
        setToastMessage("This alert was created before message templates. Please choose an approved message.");
        setToastType("warning");
      }
    }
  };
  const handleCancelClick = () => {
    if (hasFormChanges()) {
      setPendingAction(() => resetForm);
      setShowDiscardModal(true);
    } else {
      resetForm();
    }
  };
  const handleDiscardChanges = () => {
    setShowDiscardModal(false);
    setPendingAction(null);
    resetForm();
  };
  const handleSaveFromModal = () => {
    if (pendingAction) {
      pendingAction();
    }
    setShowDiscardModal(false);
    setPendingAction(null);
  };
  const keyForRerender = `${rowsPerPage}_${data?.length}`;
  const columns = [

    {
      name: 'TITLE',
      selector: row => row?.title ?? "",
      sortable: true,
      minWidth: '150px',
    },
    {
      name: 'icon',
      cell: (row) => row?.logo?.length > 0 ? <img src={`${image}${row.logo}`} alt="Image" /> : null,
      sortable: false,
      minWidth: '70px',
    },
    // {
    //   name: 'Scheduled Date',
    //   selector: row => row?.scheduleddate
    //     ? row.scheduleddate.split('-').reverse().join('/')
    //     : '',
    //   sortable: true,
    // },
    {
      name: 'Scheduled Date & Time',
      selector: row => {
        if (!row?.scheduleddate) return '';

        const date = new Date(row.scheduleddate);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        const rawHours = date.getHours();
        const ampm = rawHours >= 12 ? 'PM' : 'AM';
        const hours = String(rawHours % 12 || 12).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        return `${month}/${day}/${year} ${hours}:${minutes} ${ampm}`;
      },
      sortable: true,
      width: '180px',
    },
    {
      name: 'Status',
      selector: row => row?.status ?? "",
      sortable: true,
      minWidth: '110px',
    },

    {
      name: <span style={{ whiteSpace: 'nowrap', display: 'block', textAlign: 'center' }}>Actions</span>,
      cell: (props) =>

        subValDashboard && subValDashboard.delete && subValDashboard.edit && (subValDashboard.delete.display === true || subValDashboard.edit.display === true) &&
        <div className="d-flex">
          {subValDashboard?.edit?.display === true && props?.status !== "COMPLETED" &&
            <a
              className={`${subValDashboard && subValDashboard.edit && subValDashboard.edit.enable === false ? 'pe-none' : ''} text-success action-button`}
              onClick={() => handleEdit(props)}
              onKeyDown={keyActivate(() => handleEdit(props))}
              id="alert-edit-button"><i className="mdi mdi-pencil font-size-18"></i></a>
          }
          <a
            style={{ position: "inherit" }}
            onClick={() => handleResend(props)}
            onKeyDown={keyActivate(() => handleResend(props))}
            className="text-primary action-button"
            title="Resend"
            id="alert-resend-button">
            <i className="mdi mdi-send font-size-18"></i>
          </a>
          <a
            style={{ position: "inherit" }}
            onClick={() => handlePreview(props)}
            onKeyDown={keyActivate(() => handlePreview(props))}
            className="text-info action-button"
            title="Preview"
            id="alert-preview-button">
            <i className="mdi mdi-eye font-size-18"></i>
          </a>
          {subValDashboard && subValDashboard.delete && subValDashboard.delete.display === true &&
            <a style={{ position: "inherit" }} onClick={() => handleDelete(props?.promotionid)} onKeyDown={keyActivate(() => handleDelete(props?.promotionid))}
              className={`${subValDashboard && subValDashboard.delete && subValDashboard.delete.enable === false ? 'pe-none' : ''} text-danger action-button`}
              id="alert-delete-button" ><i className="mdi mdi-delete font-size-18"></i></a>
          }
        </div>

      ,
      ignoreRowClick: true,
      allowOverflow: true,
      center: true,
      width: '150px',
      minWidth: '150px',
    },

  ];
  const handleDelete = (id) => {
    setIsDelete(true)
    setpromotionid(id)
  }

  // Round up to the next 15-minute interval so the picker always lands on a valid slot
  const roundUpTo15Min = (date) => {
    const d = new Date(date);
    const rem = d.getMinutes() % 15;
    if (rem !== 0) d.setMinutes(d.getMinutes() + (15 - rem));
    d.setSeconds(0);
    d.setMilliseconds(0);
    return d;
  };

  const handleResend = (data) => {
    setErrors({});

    const originalDate = data.scheduleddate ? new Date(data.scheduleddate) : null;
    const now = new Date();
    const isDateInPast = originalDate && originalDate < now;
    const resolvedDate = isDateInPast ? roundUpTo15Min(now) : originalDate;

    // Normalize storeid: null / undefined / empty string all map to "ALL"
    const location = data.storeid || "ALL";

    const resendData = {
      ...data,
      promotionid: '',
      scheduleddate: resolvedDate,
      storeid: location === "ALL" ? undefined : location,
    };
    setFormData(resendData);
    setInitialFormData(resendData);
    setIsResend(true);

    setSelectedLocation(location);
    restoreTemplateSelection(data);
    getVisitorGroups(location, true, data.visitor || "");

    if (isDateInPast) {
      setToastMessage("The scheduled date/time was in the past and has been reset to now. Please review before saving.");
      setToastType("warning");
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handlePreview = (data) => {
    setPreviewAlert(data);
  };
  const handlePageChange = (page) => {
    GetTimeActivity()
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage) => {
    GetTimeActivity()
    setRowsPerPage(newPerPage);
  };

  // // console.log('datattatatattatat',data)
  useEffect(() => {
    setRoute("user")
    //  GetClientDataContext()
    setActiveMenuId(200003)
    setActiveMenuObj({
      "Client Management": false,
      "Contact Management": false,
      "Reports": false
    })
    userActivity();
  }, []);
  const userActivity = () => {
    let path = window.location.pathname.split("/");
    const pageName = path[path.length - 1];
    let presentTime = moment();
    let payload;

    payload = {
      "userid": localStorage.getItem("userId"),
      "pagename": pageName,
      "pageurl": window.location.href,
      "starttime": presentTime,
      "useragent": JSON.parse(localStorage.getItem("loc"))

    };


    const previousId = localStorage.getItem("previousid");
    const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


    axios({
      method: 'POST',
      url: urlLink,
      data: payload
    })
      .then(function (response) {
        if (response?.data?.statusCode === 200) {
          localStorage.setItem("previousid", response?.data?.result)
        }
      });
  }
  const GetUserData = async () => {
    GetTimeActivity()
    try {

      const response = await tmdbApi.getUserData({});

      if (response?.statusCode === 200) {

        setUserData(response?.result?.[0]);
        localStorage.setItem("ClientName", response?.result?.[0]?.name)
        localStorage.setItem("ClientType", response?.result?.[0]?.type)
        let userArr = response?.result?.[0]?.permissions

        const obj = userArr.reduce((acc, item) => {
          if (item.submenus) acc[item.menu] = false;
          return acc;
        }, {});
        // // console.log('objjjjjjjj--->',obj)
        // setActiveMenuObj(obj)

        // console.log('response?.result?.[0]', response?.result?.[0])
      }
    } catch {
      // console.log("error");
    }
  };



  //  useEffect(() => {


  //      // console.log("trueeeeeeeeee",searchedFlag);
  //      if (searchedFlag) { 
  //          // console.log("came") 
  //          handleSearch();
  //      } else {
  //          // console.log("called get all deals") 
  //          User();
  //      }

  //  }, [searchedFlag]);

  const PageLoad = (e) => {
    const pagevalue = e.target.value;
    //setPerpage(pagevalue);
    setitemsPerPage(pagevalue);
    setcurrentPage(1);
    setmaxPageNumberLimit(5);
    setminPageNumberLimit(0);

  }


  const User = (e) => {
    GetTimeActivity()
    setIsLoading(true)
    const token = localStorage.getItem("token")
    axios({
      method: 'GET',
      url: lambda + '/users?appname=' + appname + "&token=" + token,
    })
      .then(function (response) {
        // console.log("response", response);
        if (response?.data?.result === "Invalid token or Expired") {
          setShowSessionPopupup(true)
        } else {
          setUser(response?.data?.result);
          setData(response?.data?.result?.data);
          global.exportExcelData = response?.data?.result?.data



          setIsLoading(false);
          setUserSearch("");
          setSearchedFlag(false);
        }
      }).catch((err) => {
        // console.log('error', err);
        setTableErrMsg(true)
        setIsLoading(false);
      });
  }





  const handleSearch = (e, flagggg) => {
    GetTimeActivity()
    if (flagggg) {
      setcurrentPage(1);
    }
    setmaxPageNumberLimit(5);
    setminPageNumberLimit(0);
    if (flagggg === "normalsearch") {
      setSearchedFlag(true)
    }
    setFlag(true)
    if (usersearch === "") {
      User();
    }
    else {
      setIsLoading(true)
      const token = localStorage.getItem("token")
      axios({
        method: 'GET',
        url: lambda + '/users?appname=' + appname + "&search=" + usersearch + "&token=" + token,
      })
        .then(function (response) {
          if (response?.data?.result === "Invalid token or Expired") {
            setShowSessionPopupup(true)
          } else {
            // console.log("response", response);
            setUser(response?.data?.result);
            setData(response?.data?.result?.data);
            global.exportExcelData = response?.data?.result?.data



            setIsLoading(false)
          }
        }).catch((err) => {
          // console.log('error', err);
          setTableErrMsg(true)
          setIsLoading(false);
        });
    }
  }
  const validateForm = () => {
    // console.log("Validating Form...");

    let tempErrors = {};
    let isValid = true;

    if (!activeTemplate) {
      tempErrors.template = "Please select an alert message";
      isValid = false;
    } else if (missingVars.length > 0) {
      tempErrors.templateVars =
        `Please complete: ${missingVars.map(v => v.name.replace(/_/g, ' ')).join(', ')}`;
      isValid = false;
    } else if (previewBadChars.length > 0 || previewOverLimit) {
      tempErrors.templateVars = "This message can't be sent as written. Please adjust your entries.";
      isValid = false;
    }
    if (!formData?.visitorId || formData.visitorId.length === 0) {
      tempErrors.visitor = "Please select at least one visitor group";
      isValid = false;
    }
    // if (!formData?.scheduleddate || formData?.scheduleddate?.trim() === "") {
    //   tempErrors.scheduleddate = "schedule date is required";
    //   isValid = false;
    // }

    if (!formData?.scheduleddate) {
      tempErrors.scheduleddate = "Schedule date is required";
      isValid = false;
    }


    // if (!formData.status) {
    //   tempErrors.status = "status is required";  // Fixed typo
    //   isValid = false;
    // }

    // if (!formData.logo || formData.logo.trim() === "") {
    //     tempErrors.logo = "Icon is required";
    //     isValid = false;
    // }

    setErrors(tempErrors);  // Update state with errors

    return isValid;  // Return validation result
  };




  // const handleFileChange = (event) => {
  //   setErrors({ ...errors, logo: "" })
  //   const selectedFile = event.target.files[0];

  //   if (!selectedFile) return; // Prevents error if no file is selected

  //   const allowedType = "image/svg+xml"; // Allow only SVG files
  //   let fileSize = 1048612 * 1; // 5MB

  //   if (selectedFile.type !== allowedType) {
  //     // setFileError("Only SVG images are allowed.");
  //     setToastMessage("Only SVG images are allowed.")
  //     setToastType("error")
  //     // setFileSizeError(true);
  //     return;
  //   }

  //   if (selectedFile.size < fileSize) {
  //     const previewUrl = URL.createObjectURL(selectedFile);
  //     setFormData({ ...formData, logo: previewUrl }); // Store preview URL
  //     setFilesData([selectedFile]); // Store file data

  //   } else {
  //     setFileError("File size greater than 1MB.");
  //     setFileSizeError(true);
  //     event.target.value = null;

  //   }
  // };
  const handleFileChange = (event) => {
    setErrors({ ...errors, logo: "" });
    const selectedFile = event.target.files[0];

    if (!selectedFile) return;

    const allowedTypes = ["image/svg+xml", "image/png", "image/jpeg", "image/jpg"]; // Allowed file types
    const maxFileSize = 1 * 1024 * 1024; // 1MB in bytes

    if (!allowedTypes.includes(selectedFile.type)) {
      setToastMessage("Only JPG, JPEG, PNG, or SVG images are allowed.");
      setToastType("error");
      return;
    }

    if (selectedFile.size > maxFileSize) {
      setFileError("File size must be less than or equal to 1MB.");
      setFileSizeError(true);
      event.target.value = null;
      return;
    }

    const previewUrl = URL.createObjectURL(selectedFile);
    setFormData({ ...formData, logo: previewUrl });
    setFilesData([selectedFile]);
  };


  const handleUploadSubmit = async () => {

    const ObjectID = require("bson-objectid");
    const uniqueId = new ObjectID().toString();
    // setLocationId(locationId)
    const validate = validateForm()
    if (validate) {
      setBtnLoader(true)
      if (filesData && filesData?.length > 0) {

        const uploadPromises = Array.from(filesData).map(async (file) => {
          const timestamp = Date.now();
          const fileExtension = file?.name?.split('.').pop();
          const clientid = localStorage.getItem('userId');
          const token = localStorage.getItem('token');
          const ObjectID = require("bson-objectid");

          const uniqueId = new ObjectID().toString();
          let uploadFilePath;
          let bucket;

          // Check the file type
          if (file.type.startsWith('image/')) {
            // File is an image
            let filenameReplace = file.name.replace(/ /g, "_")
            uploadFilePath = `${appname}/${uniqueId}/${filenameReplace.split('.')[0]}_image_${timestamp}.${fileExtension}`;
            bucket = window?.site?.common?.resourceBucket; // Use resource bucket for images
            const data = {
              source_bucket: bucket, // Use the correct bucket based on file type
              sourcepath: uploadFilePath
            };
            // console.log("data", data)
            const newFile = [{
              filename: filenameReplace.split('.')[0],
              filepath: uploadFilePath,
              fileid: uniqueId,
              filetype: file.type,
              filesize: file.size,
              fileformat: fileExtension
            }]
            const updatedFiles = newFile;
            // console.log("updatedFiles", updatedFiles)
            setFiles(updatedFiles);

            const uploadPromise = axios.post(
              `${lambda}/uploadURL?appname=${appname}`,
              data,
              { headers: { 'Content-Type': 'application/json' } }
            ).then(async uploadUrlResponse => {
              if (uploadUrlResponse.data && uploadUrlResponse.data.result) {
                const url = uploadUrlResponse.data.result;

                return axios.put(url, file, {
                  headers: {
                    'Content-Type': file.type,
                    'Cache-Control': 'no-cache'
                  }
                }).then(async uploadResponse => {
                  if (uploadResponse.status === 200) {
                    // setFiles([...files, ...newFile]); 
                    // handleSubmit(updatedFiles);
                    handleCreate(updatedFiles)
                  } else {
                    throw new Error('Failed to upload file to S3');
                  }
                });
              } else {
                throw new Error('Failed to get upload URL');
              }
            });


          }


        });

        try {
          //const results = await Promise.all(uploadPromises);
          await Promise.all(uploadPromises);

        } catch (error) {
          console.error('Error during file upload:', error);
        }
      } else {
        // handleSubmit([], uniqueId);

        handleCreate([]);

      }
    }


  }
  //   useEffect(() => {
  //   // Register global flag for unsaved changes
  //   window.__HAS_UNSAVED_CHANGES__ = hasFormChanges();

  //   // Register global function to show modal
  //   window.__SHOW_UNSAVED_MODAL__ = (action) => {
  //     setPendingAction(() => action);
  //     setShowDiscardModal(true);
  //   };

  //   // Cleanup on unmount
  //   return () => {
  //     window.__HAS_UNSAVED_CHANGES__ = false;
  //     window.__SHOW_UNSAVED_MODAL__ = null;
  //   };
  // }, [formData, initialFormData]); // Re-run when form data changes
  const handleCreate = async (filesData) => {
    let siteConfig = window?.site?.common;
    let logoImage = filesData?.[0]?.filepath || "";
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const uniqueVisitorIds = [...new Set(formData?.visitorId || [])];
    // Title and body are rendered server-side from the template, so they are
    // deliberately not sent here — only the template id and its variables.
    const payload = {
      createdBy: {
        name: userData?.contactname,
        clientid: localStorage.getItem("clientid"),
      },
      templateId: selectedTemplateId,
      templateVariables: templateVars,
      scheduleddate: formData?.scheduleddate,
      visitorId: uniqueVisitorIds,
      visitor: formData?.visitor,
      logo: filesData?.length > 0 ? logoImage : formData?.logo,
      timezone: timeZone,
      storeid: selectedLocation !== "ALL" ? selectedLocation : undefined,
      // status: formData?.status, // Uncomment if using
    };

    try {
      if (formData?.promotionid) {
        // Update alert
        const response = await axios.post(
          `${lambda}/editAlerts?appname=${appname}&userid=${localStorage.getItem("userId")}&promotionid=${formData?.promotionid}`,
          payload
        );

        if (response?.data?.result?.error === "INVALID_ALERT") {
          setErrors(prev => ({ ...prev, templateVars: response.data.result.messages.join(' ') }));
          setToastMessage(response.data.result.messages.join(' '));
          setToastType("error");
        } else if (response?.data?.result === "Notification name already exists") {
          setToastMessage("Notification name already exists.");
          setToastType("warning");
        } else if (response?.data?.result === "updated successfully") {
          setToastMessage("Alerts Updated Successfully");
          setToastType("success");
          setFilesData([]);
          setFormData({
            title: '',
            description: '',
            visitor: '',
            visitorId: [],
            scheduleddate: '',
            logo: '',
            promotionid: '',
            status: ''
          });
          setInitialFormData({
            title: '',
            description: '',
            visitor: '',
            visitorId: [],
            scheduleddate: '',
            logo: '',
            promotionid: '',
            status: ''
          });
          setSelectedGroups([]);
          setSelectedLocation("ALL");
          getVisitorGroups("ALL");
          setTimeout(getAlerts, 2000);
        }
      } else {
        // Create alert
        const token = localStorage.getItem("token");
        const response = await axios.post(
          `${lambda}/alerts?appname=${appname}&token=${token}`,
          payload
        );

        if (response?.data?.result?.error === "INVALID_ALERT") {
          // The server re-validates every message; surface exactly why it refused.
          setErrors(prev => ({ ...prev, templateVars: response.data.result.messages.join(' ') }));
          setToastMessage(response.data.result.messages.join(' '));
          setToastType("error");
        } else if (response?.data?.result === "Notification name already exists") {
          setToastMessage("Alerts name already exists.");
          setToastType("warning");
        } else {
          setToastMessage("Alerts Created Successfully");
          setToastType("success");
          setFilesData([]);
          setFormData({
            title: '',
            description: '',
            visitor: '',
            visitorId: [],
            scheduleddate: '',
            logo: '',
            promotionid: '',
            status: ''
          });
          setInitialFormData({
            title: '',
            description: '',
            visitor: '',
            visitorId: [],
            scheduleddate: '',
            logo: '',
            promotionid: '',
            status: ''
          });
          setSelectedGroups([]);
          setSelectedLocation("ALL");
          getVisitorGroups("ALL");
          setTimeout(getAlerts, 2000);
        }
      }
    } catch (error) {
      console.error("Alert creation failed:", error);
      setToastMessage("An error occurred while processing the alert.");
      setToastType("error");

      setAlertConfig({
        title: "Error",
        type: "error",
        message: error?.response?.data?.message || "Something went wrong",
      });
      setShowAlert(true);
    } finally {
      setIsLoading(false);
      setBtnLoader(false);
    }
  };



  const handleDeleteAlert = async () => {
    setDeleteLoader(true)
    try {
      //   // console.log("formData before deletion:", formData);

      const payload = {
        // archivedBy: {
        //   name: userData?.name, 
        //   userid: useruniqueid
        // },
        status: "ARCHIVE",
        // archivedOn: new Date().toISOString(),
        // logo: filesData?.length > 0 ? logoImage : formData?.logo,

      };


      const response = await axios.post(
        `${lambda}/deleteAlerts?appname=${appname}&userid=${useruniqueid}&promotionid=${promotionid}`,
        payload
      );

      // console.log("API Response:", response);

      setDeleteLoader(false)
      setToastMessage(" Alert Deleted Successfully");
      setToastType("success");
      setIsDelete(false)
      // Reset form after update
      setFormData({
        title: '',
        description: '',
        visitor: '',
        visitorId: [],
        scheduleddate: '',
        logo: '',
        promotionid: '',
        status: ''
      });
      setSelectedLocation("ALL");
      getVisitorGroups("ALL");

      setTimeout(() => {
        getAlerts(); // Fetch updated notification list
      }, 2000); // Ensure toast is visible before refresh


    } catch (error) {
      console.error("Error updating notification:", error);
      setToastMessage("Failed to update notification");
      setToastType("error");
    } finally {
      setBtnLoader(false);
    }
  };


  // The approved template set for this client (universal + their vertical).
  // Promotional templates are withheld by the server until promotional sending
  // is enabled, so whatever arrives here is safe to offer.
  const getAlertTemplates = async () => {
    setTemplatesLoading(true);
    try {
      const clientid = localStorage.getItem("clientid");
      const response = await axios.get(
        `${lambda}/alertTemplates?appname=${appname}&clientid=${clientid}`
      );
      setTemplates(response?.data?.result?.templates || []);
    } catch (error) {
      console.error("Error fetching alert templates:", error);
      setToastMessage("Could not load alert templates. Please reload the page.");
      setToastType("error");
    } finally {
      setTemplatesLoading(false);
    }
  };

  const getStores = async () => {
    try {
      const token = localStorage.getItem("token");
      const clientid = localStorage.getItem("clientid");
      const response = await axios({
        method: 'POST',
        url: `${lambda}/getStores?appname=${appname}&clientid=${clientid}&token=${token}`,
      });
      if (response?.data?.result === "Invalid token or Expired") {
        setShowSessionPopupup(true);
      } else {
        setStoreData(response?.data?.result || []);
      }
    } catch (error) {
      console.error("Error fetching stores:", error);
    }
  };

  const getVisitorGroups = async (storeId, skipFormReset = false, restoreVisitorLabel = "") => {
    setGroupsLoading(true);
    setVisitorGroups([]);
    setSelectedGroups([]);
    if (!skipFormReset) {
      setFormData(prev => ({ ...prev, visitor: "", visitorId: [] }));
    }
    try {
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const today = new Date();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      const year = today.getFullYear();
      const date = `${month}-${day}-${year}`;

      const clientid = localStorage.getItem("clientid");
      let url = `${lambda}/visitorGroups?appname=${appname}&timezone=${encodeURIComponent(timeZone)}&date=${date}&clientid=${clientid}`;
      if (storeId && storeId !== "ALL") {
        url += `&storeid=${storeId}`;
      }

      const response = await axios.get(url);
      if (response?.data?.result?.groups) {
        let groups = response.data.result.groups;

        groups = groups.map(g => {
          if (g.groupType === "REPEAT_VISITORS") return { ...g, label: "All Repeat Visitors" };
          if (g.groupType === "FIRST_TIME_VISITORS") return { ...g, label: "All First Time Visitors" };
          return g;
        });

        const repeatGroup = groups.find(g => g.groupType === "REPEAT_VISITORS");
        const firstTimeGroup = groups.find(g => g.groupType === "FIRST_TIME_VISITORS");
        const rest = groups.filter(g => g.groupType !== "REPEAT_VISITORS" && g.groupType !== "FIRST_TIME_VISITORS");
        const pastIdx = rest.findIndex(g => g.groupType === "ALL_PAST_VISITORS");
        if (pastIdx !== -1) {
          rest.splice(pastIdx + 1, 0, ...[repeatGroup, firstTimeGroup].filter(Boolean));
          groups = rest;
        }

        setVisitorGroups(groups);

        if (restoreVisitorLabel) {
          const labelsToRestore = restoreVisitorLabel.split(",").map(l => l.trim());
          const groupsToRestore = groups
            .filter(g => labelsToRestore.includes(g.label))
            .map(g => ({ value: g.groupType, label: g.label }));
          setSelectedGroups(groupsToRestore);
          // Only overwrite formData visitor if we actually found matching groups;
          // otherwise preserve the raw visitor value already set from the alert data
          if (groupsToRestore.length > 0) {
            updateFormDataFromGroups(groupsToRestore, groups, true);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching visitor groups:", error);
    } finally {
      setGroupsLoading(false);
    }
  };

  const updateFormDataFromGroups = (selectedGroups, allGroups = visitorGroups, syncInitial = false) => {
    const allVisitorIds = [];
    const selectedLabels = [];

    selectedGroups.forEach(selectedGroup => {
      const group = allGroups.find(g => g.groupType === selectedGroup.value);
      if (group) {
        (group.visitors || []).forEach(v => {
          if (!allVisitorIds.includes(v.visitorId)) {
            allVisitorIds.push(v.visitorId);
          }
        });
        selectedLabels.push(group.label);
      }
    });

    const update = { visitor: selectedLabels.join(", "), visitorId: allVisitorIds };
    setFormData(prev => ({ ...prev, ...update }));
    if (syncInitial) {
      setInitialFormData(prev => ({ ...prev, ...update }));
    }
    setErrors(prev => ({ ...prev, visitor: "" }));
  };

  const handleLocationChange = (e) => {
    const storeId = e.target.value;
    setSelectedLocation(storeId);
    setSelectedGroups([]);
    setFormData(prev => ({ ...prev, visitor: "", visitorId: [] }));
    setErrors(prev => ({ ...prev, visitor: "" }));
    getVisitorGroups(storeId);
  };

  // const handleGroupToggle = (groupType, isSelected) => {
  //   setSelectedGroups(prevGroups => {
  //     const newSelectedGroups = { ...prevGroups, [groupType]: isSelected };

  //     const allIds = [];
  //     const selectedLabels = [];
  //     visitorGroups.forEach(group => {
  //       if (newSelectedGroups[group.groupType]) {
  //         (group.visitors || []).forEach(v => allIds.push(v.visitorId));
  //         selectedLabels.push(group.label);
  //       }
  //     });

  //     const uniqueIds = [...new Set(allIds)];
  //     setFormData(prev => ({
  //       ...prev,
  //       visitor: selectedLabels.join(", "),
  //       visitorId: uniqueIds
  //     }));
  //     setErrors(prev => ({ ...prev, visitor: "" }));

  //     return newSelectedGroups;
  //   });
  // };

  const handleGroupSelection = (selectedOptions) => {
    setSelectedGroups(selectedOptions || []);
    updateFormDataFromGroups(selectedOptions || []);
  };
  // console.log("vistorDatatatatata", visitorData)
  const getAlerts = async () => {
    setIsLoading(true)
    try {
      const token = localStorage.getItem("token");
      const clientid = localStorage.getItem("clientid");
      const response = await axios.get(`${lambda}/getAlerts?appname=${appname}&clientid=${clientid}&token=${token}`);

      if (response?.data?.result === "Invalid token or Expired") {
        setShowSessionPopupup(true);
        setIsLoading(false)
      } else {
        setData(response?.data?.result);
        setIsLoading(false)
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };
  // console.log("errorsssssssssssssssssssssssssss", errors)
  const handleRemove = () => {
    setFilesData([])
    setFormData({ ...formData, logo: "" })
  }
  const applyTemplate = (template) => {
    setSelectedTemplateId(template ? template.id : "");
    setTemplateVars({});
    setErrors((prev) => ({ ...prev, template: "", templateVars: "" }));

    // Pre-select the template's recommended visitor groups so the sender starts
    // from a sensible audience rather than an empty one.
    if (template && visitorGroups.length > 0) {
      const defaults = (template.defaultGroups || [])
        .map(label => visitorGroups.find(g => g.label === label))
        .filter(Boolean)
        .map(g => ({ value: g.groupType, label: g.label }));
      if (defaults.length > 0) {
        setSelectedGroups(defaults);
        updateFormDataFromGroups(defaults);
      }
    }
  };

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
    applyTemplate(null);
  };

  const handleTemplateChange = (event) => {
    applyTemplate(templates.find(t => t.id === event.target.value) || null);
  };

  const handleVarChange = (name, value) => {
    setTemplateVars((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, templateVars: "" }));
  };

  // console.log("formData-------------------------->", formData)
  //  const handleKeypress = (e) => {
  //      //it triggers by pressing the enter key
  //      GetTimeActivity()   
  //      if ((e.key === "Enter")) {
  //          setTimeout(function () {
  //              handleSearch();
  //          }, 1000);
  //      }
  //  };
  const handleAddUser = (e) => {
    GetTimeActivity()
    navigate("/adduser");
  }
  const handleClose = () => {
    setIsDelete(false)
  }
  const handleEditUser = (e, paramuserid) => {
    // console.log('paramuserid', paramuserid)
    GetTimeActivity()
    navigate("/edituser/" + paramuserid);
  }
  const handleViewUser = (e, paramuserid) => {
    GetTimeActivity()
    // console.log('paramuserid', paramuserid)

    navigate("/viewuser/" + paramuserid);
  }

  const clearSearch = () => {
    GetTimeActivity()
    setUserSearch("");
    User();
    setcurrentPage(1);
  }

  const customNoRecords = () => {
    return (

      <div className="empty-state-body empty-record"  >
        <div className="empty-state__message">
          <span className="material-icons">summarize</span>
          <p className="form-check font-size-16">No alerts were found</p>
        </div> </div>
    )
  }
  const handleExport = () => {

    // let k = defaultData || exportExcelData
    const modifiedArray = global.exportExcelData.map((each, i) => ({
      "S.NO": i + 1,
      "NAME": each?.name ?? "",
      "USER TYPE": each?.type ?? "",
      "EMAIL ID": typeof each?.emailid === "object" && each?.emailid !== null && each?.emailid.length > 1 ? each?.emailid.join(', ') : each?.emailid ?? "",
      "PHONE NUMBER": each?.phone ?? "",
      "STATUS": each?.status ?? "",

    }));

    exportToExcel(modifiedArray, "data");

  }
  function exportToExcel(jsonData, fileName) {
    delete jsonData['_id'];
    const worksheet = XLSX.utils.json_to_sheet(jsonData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data1 = new Blob([excelBuffer], { type: 'application/octet-stream' });
    //FileSaver.saveAs(data, `${fileName}.xlsx`);
    FileSaver.saveAs(data1, `UsersData.xlsx`);
    // console.log('data22222--->', data)
  }
  const customSort = (rows, selector, direction) => {
    const sortedData = rows.slice().sort((rowA, rowB) => {
      // use the selector function to resolve your field names by passing the sort comparators
      // const aField = selector(rowA);
      const aField = String(selector(rowA)).toLowerCase();

      //  const bField = selector(rowB);
      const bField = String(selector(rowB)).toLowerCase();

      let comparison = 0;

      if (aField > bField) {
        comparison = 1;
      } else if (aField < bField) {
        comparison = -1;
      }

      return direction === 'desc' ? comparison * -1 : comparison;
    });

    // Log the sorted data to the console
    // setSortedRecomData(sortedData)
    global.exportExcelData = sortedData
    // // console.log('Sorted Data------>:', sortedData);

    return sortedData;
  };
  // // console.log("showSessionPopupup",showSessionPopupup)
  const formTitle = formData?.promotionid ? 'EDIT ALERT' : isResend ? 'RESEND ALERT' : 'ADD ALERTS';
  const categories = [...new Set(templates.map(t => t.category))].sort();
  const templatesInCategory = templates.filter(t => t.category === selectedCategory);
  const activeTemplate = templates.find(t => t.id === selectedTemplateId) || null;

  // Brand tokens are auto-filled server-side; the preview approximates them so
  // the character counter is meaningful. With "All Locations" selected the
  // longest name is used, since that is the worst case for the segment limit.
  const previewLocationName = (() => {
    if (selectedLocation && selectedLocation !== "ALL") {
      const store = storeData.find(s => (s.storeid || s._id) === selectedLocation);
      return store?.name || "";
    }
    return storeData.reduce((longest, s) => (s?.name?.length > longest.length ? s.name : longest), "");
  })();

  const preview = renderPreview(activeTemplate, templateVars, {
    location_name: previewLocationName,
    company_name: localStorage.getItem("ClientName") || userData?.name || ""
  });

  const missingVars = (activeTemplate?.variables || []).filter(v => !templateVars[v.name]);
  const previewBadChars = preview ? findNonGsm7(preview.body) : [];
  const previewOverLimit = !!preview && preview.smsLength > SMS_SEGMENT_LIMIT;
  const canPublish = !!activeTemplate && missingVars.length === 0
    && previewBadChars.length === 0 && !previewOverLimit;

  // Every variable renders as a constrained control — never a free-text box —
  // so an invalid value can't be entered in the first place.
  const renderVariableInput = (v) => {
    const value = templateVars[v.name] ?? '';
    const label = v.name.replace(/_/g, ' ').toUpperCase();
    const common = { id: `var-${v.name}`, className: "form-control border-style" };

    let control;
    if (v.type === 'time') {
      control = (
        <select {...common} className="form-select select-style border-style"
          value={value} onChange={(e) => handleVarChange(v.name, e.target.value)}>
          <option value="">Select a time</option>
          {TIME_OPTIONS.map(t => <option key={t} value={t}>{t}</option>)}
        </select>
      );
    } else if (v.type === 'dropdown') {
      control = (
        <select {...common} className="form-select select-style border-style"
          value={value} onChange={(e) => handleVarChange(v.name, e.target.value)}>
          <option value="">Select an option</option>
          {v.options.map(o => <option key={o} value={o}>{o}</option>)}
        </select>
      );
    } else if (v.type === 'when_hybrid') {
      const isDate = DATE_PATTERN.test(value);
      control = (
        <>
          <select {...common} className="form-select select-style border-style"
            value={isDate ? '__date__' : value}
            onChange={(e) => handleVarChange(
              v.name,
              e.target.value === '__date__' ? formatShortDate(new Date()) : e.target.value
            )}>
            <option value="">Select an option</option>
            {v.options.map(o => <option key={o} value={o}>{o}</option>)}
            <option value="__date__">a specific date...</option>
          </select>
          {isDate && (
            <DatePicker
              selected={moment(value, 'MMM D').toDate()}
              onChange={(d) => handleVarChange(v.name, formatShortDate(d))}
              dateFormat="MMM d"
              minDate={new Date()}
              className="form-control border-style mt-2"
            />
          )}
        </>
      );
    } else if (v.type === 'date') {
      control = (
        <DatePicker
          selected={value ? moment(value, 'MMM D').toDate() : null}
          onChange={(d) => handleVarChange(v.name, formatShortDate(d))}
          dateFormat="MMM d"
          minDate={new Date()}
          placeholderText="Select a date"
          className="form-control border-style"
        />
      );
    } else if (v.type === 'percent') {
      control = (
        <input {...common} type="number" min={v.min} max={v.max} value={value}
          onChange={(e) => handleVarChange(v.name, e.target.value)} />
      );
    } else {
      // short_text — capped at the template's limit, with the count shown.
      control = (
        <>
          <input {...common} type="text" maxLength={v.maxLength} value={value}
            placeholder={`Max ${v.maxLength} characters`}
            onChange={(e) => handleVarChange(v.name, e.target.value)} />
          <span style={{ fontSize: '10px', color: '#888' }}>
            {gsm7Length(value)}/{v.maxLength}
          </span>
        </>
      );
    }

    return (
      <div className="mb-3" key={v.name}>
        <label className="form_label span-style" htmlFor={`var-${v.name}`}>
          {label}<span className="required">*</span>
        </label>
        {control}
      </div>
    );
  };

  // Nothing sends straight from the form — the sender confirms the fully
  // rendered message and the audience first.
  const handlePublishClick = () => {
    if (validateForm()) setShowConfirm(true);
  };

  const handleConfirmSend = () => {
    setShowConfirm(false);
    handleUploadSubmit();
  };

  const recipientCount = formData?.visitorId?.length || 0;
  const locationCount = selectedLocation === "ALL" ? (storeData?.length || 0) : 1;
  const isSafetyAlert = activeTemplate?.category === 'Safety';

  return (
    <>
      {showSessionPopupup && <SessionPopup />}
      <div id="layout-wrapper">
        <Header />
        <Sidebar />
        <Modal className="access-denied" show={showDiscardModal} centered>
          <div className="modal-body enquiry-form">
            <div className="container">
              <button
                className="close-btn"
                onClick={() => {
                  setShowDiscardModal(false);
                  setPendingAction(null);
                }}
              >
                <span className="material-icons">close</span>
              </button>

              <span className="material-symbols-outlined access-denied-icon">
                warning
              </span>

              <h3>Unsaved Changes</h3>
              <p>
                You have unsaved changes.<br />
                Do you want to discard them or {formData?.promotionid ? 'update' : 'save'}?
              </p>

              <div className="popup-footer d-flex gap-2">
                <button className="fill_btn" onClick={handleDiscardChanges}>
                  Discard
                </button>

                <button className="fill_btn yellow-gradient" onClick={handleSaveFromModal}>
                  {formData?.promotionid ? 'Update' : 'Save'} & Continue
                </button>
              </div>
            </div>
          </div>
        </Modal>
        {/* Start right Content here  */}
        {/* {isLoading ? <Loader /> : */}
        <div id="userManagement" className="main-content user-management alerts-page">
          <div id="pageContent" className="page-content">
            <div id="containerFluid" className="container-fluid">
              <div id="breadcrumbRow" className="row breadcrumb">
                <div id="breadcrumbCol" className="col-lg-12">
                  <div id="breadcrumbWrapper" className="d-flex align-items-center">
                    <div id="breadcrumbContent" className="flex-grow-1">
                      <h4 id="notificationManagementTitle" className="mb-2 card-title">Alerts</h4>
                      <p id="menuPath" className="menu-path">
                        {/* <span>Spot Management</span> / <b>ADD NOTIFICATION</b> */}
                        {/* <span><b>ADD NOTIFICATIONS</b></span> */}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div id="tableDataRow" className="row table-data">
                <div id="tableDataCol" className="col-12">
                  <div id="notificationCard" className="card">
                    <div id="notificationCardBody" className="card-body">
                      <div id="addnotificationRow" className="row add-notification-page-style">
                        <div id="addnotificationCol" className="col-md-3 pe-1">
                          <div id="basicPlanLeft" className="basic_plan">
                            {/* <h4 id="addnotificationTitle" className="form-title">ADD ALERTS</h4> */}
                            <div
                              className="d-flex align-items-center justify-content-between mb-3"
                            >
                              <h4 id="addnotificationTitle" className="form-title mb-0">
                                {formTitle}
                              </h4>

                              {(formData?.promotionid || isResend) &&
                                <button
                                  type="button"
                                  className="btn-close"
                                  aria-label="Close"
                                  onClick={handleCancelClick}
                                />
                              }
                            </div>

                            <label id="alertCategoryLabel" className="form_label mt-2 span-style" htmlFor="alertCategorySelect">
                              CATEGORY<span className="required">*</span>
                            </label>
                            <div className="input-group mb-3 mr-sm-2">
                              <select
                                id="alertCategorySelect"
                                className="form-select select-style border-style"
                                value={selectedCategory}
                                onChange={handleCategoryChange}
                                disabled={templatesLoading}
                              >
                                <option value="">{templatesLoading ? "Loading..." : "Select a category"}</option>
                                {categories.map(c => <option key={c} value={c}>{c}</option>)}
                              </select>
                            </div>

                            <label id="alertTemplateLabel" className="form_label mt-2 span-style" htmlFor="alertTemplateSelect">
                              MESSAGE<span className="required">*</span>
                            </label>
                            <div className="input-group mb-3 mr-sm-2 error-mssg-style">
                              <select
                                id="alertTemplateSelect"
                                className="form-select select-style border-style"
                                value={selectedTemplateId}
                                onChange={handleTemplateChange}
                                disabled={!selectedCategory}
                              >
                                <option value="">
                                  {selectedCategory ? "Select a message" : "Select a category first"}
                                </option>
                                {templatesInCategory.map(t => (
                                  <option key={t.id} value={t.id}>{t.title}</option>
                                ))}
                              </select>
                              {errors?.template && (
                                <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{errors.template}</span>
                              )}
                            </div>

                            {/* Locked copy is fixed; only these constrained fields are editable. */}
                            {activeTemplate && (activeTemplate.variables || []).length > 0 && (
                              <div className="mb-2">
                                {activeTemplate.variables.map(renderVariableInput)}
                              </div>
                            )}

                            {preview && (
                              <div id="alertMessagePreview" className="mb-3">
                                <div className="d-flex justify-content-between align-items-center">
                                  <label className="form_label span-style mb-0">PREVIEW</label>
                                  <span style={{
                                    fontSize: '11px',
                                    fontWeight: 600,
                                    color: previewOverLimit ? '#d33' : '#666'
                                  }}>
                                    {preview.smsLength}/{SMS_SEGMENT_LIMIT}
                                  </span>
                                </div>
                                <div className="border-style" style={{ padding: '8px 10px', borderRadius: '5px', background: '#f8f9fa' }}>
                                  <div style={{ fontWeight: 600, fontSize: '13px', color: '#222' }}>{preview.title}</div>
                                  <div style={{ fontSize: '12px', color: '#555', marginTop: '4px', whiteSpace: 'pre-wrap' }}>
                                    {preview.body}
                                    <span style={{ color: '#999' }}>{OPT_OUT_SUFFIX}</span>
                                  </div>
                                </div>
                                <span style={{ fontSize: '10px', color: '#888' }}>
                                  The opt-out line is added automatically to every text message.
                                </span>
                                {previewBadChars.length > 0 && (
                                  <div className="errormsg" style={{ fontWeight: 'bold', color: 'red', fontSize: '11px' }}>
                                    Unsupported character(s): {previewBadChars.join(' ')}
                                  </div>
                                )}
                                {previewOverLimit && (
                                  <div className="errormsg" style={{ fontWeight: 'bold', color: 'red', fontSize: '11px' }}>
                                    Message is too long for a single text message.
                                  </div>
                                )}
                              </div>
                            )}

                            <label className="form_label mt-3 span-style">LOCATION<span className="required">*</span></label>
                            <div className="input-group mb-3 mr-sm-2">
                              <select
                                className="form-select select-style border-style"
                                value={selectedLocation}
                                onChange={handleLocationChange}
                              >
                                <option value="">Select Location</option>
                                <option value="ALL">All Locations</option>
                                {storeData && storeData.map(store => (
                                  <option key={store.storeid || store._id} value={store.storeid || store._id}>
                                    {store.name}
                                  </option>
                                ))}
                              </select>
                            </div>

                            <label className="form_label mt-2 span-style">
                              VISITOR GROUPS<span className="required">*</span>
                            </label>

                            {groupsLoading ? (
                              <div className="mb-3" style={{ fontSize: '13px', color: '#888' }}>
                                Loading groups...
                              </div>
                            ) : visitorGroups && visitorGroups.length > 0 ? (
                              <div className="mb-3">
                                <Select
                                  isMulti
                                  closeMenuOnSelect={false}
                                  hideSelectedOptions={false}
                                  value={selectedGroups}
                                  onChange={handleGroupSelection}
                                  options={visitorGroups.map(group => ({
                                    value: group.groupType,
                                    label: `${group.label} (${group.count})`
                                  }))}
                                  placeholder="Select visitor groups..."
                                  className="react-select-container"
                                  classNamePrefix="react-select"
                                  styles={{
                                    control: (provided) => ({
                                      ...provided,
                                      border: '1px solid #b6b6b6',
                                      borderRadius: '5px',
                                      minHeight: '37.5px',
                                      maxHeight: '120px',
                                      overflowY: 'auto',
                                      fontSize: '11px',
                                      flexWrap: 'wrap',
                                      alignContent: 'flex-start'
                                    }),
                                    valueContainer: (provided) => ({
                                      ...provided,
                                      flexWrap: 'wrap',
                                      maxHeight: '110px',
                                      overflowY: 'auto',
                                      padding: '4px 6px',
                                      gap: '3px'
                                    }),
                                    multiValue: (provided) => ({
                                      ...provided,
                                      backgroundColor: '#e8effc',
                                      border: '1px solid #b6cdf5',
                                      borderRadius: '4px',
                                      margin: '2px'
                                    }),
                                    multiValueLabel: (provided) => ({
                                      ...provided,
                                      fontSize: '11px',
                                      color: '#065AD8',
                                      fontWeight: '500'
                                    }),
                                    multiValueRemove: (provided) => ({
                                      ...provided,
                                      fontSize: '11px',
                                      color: '#065AD8',
                                      ':hover': { backgroundColor: '#065AD8', color: '#fff' }
                                    }),
                                    option: (provided, state) => ({
                                      ...provided,
                                      fontSize: '11px',
                                      backgroundColor: state.isSelected
                                        ? '#065AD8'
                                        : state.isFocused
                                        ? '#e8effc'
                                        : '#fff',
                                      color: state.isSelected ? '#fff' : '#374151',
                                      cursor: 'pointer'
                                    })
                                  }}
                                />
                              </div>
                            ) : (
                              <div className="mb-3">
                                <Select
                                  isDisabled
                                  placeholder="Select a location to load groups"
                                  className="react-select-container"
                                  classNamePrefix="react-select"
                                  styles={{
                                    control: (provided) => ({
                                      ...provided,
                                      border: '1px solid #b6b6b6',
                                      borderRadius: '5px',
                                      minHeight: '37.5px',
                                      fontSize: '11px'
                                    })
                                  }}
                                />
                              </div>
                            )}

                            {errors?.visitor && (
                              <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>
                                {errors.visitor}
                              </span>
                            )}


                            <label id="notificationdateLabel" className="form_label mt-2 span-style">Schedule date & time<span className="required">*</span></label>
                            <div id="titleInputGroup" className="input-group mb-3 mr-sm-2 error-mssg-style d-inline-grid">


                              <DatePicker
                                selected={formData.scheduleddate}
                                onChange={(date) => {
                                  if (date) {
                                    const now = new Date();
                                    if (date.getHours() === 0 && date.getMinutes() === 0) {
                                      date.setHours(now.getHours(), now.getMinutes(), 0, 0);
                                      date = roundUpTo15Min(date);
                                    }
                                  }
                                  setFormData({ ...formData, scheduleddate: date });
                                }}
                                dateFormat="MM/dd/yyyy hh:mm aa"
                                showTimeSelect
                                minDate={new Date()}
                                timeIntervals={15}
                                filterTime={(time) => {
                                  const now = new Date();
                                  const selected = formData.scheduleddate || new Date();
                                  const isToday =
                                    selected.getFullYear() === now.getFullYear() &&
                                    selected.getMonth()    === now.getMonth()    &&
                                    selected.getDate()     === now.getDate();
                                  return isToday ? time.getTime() > now.getTime() : true;
                                }}
                                className="form-control border-style"
                                placeholderText="MM/DD/YYYY hh:mm AM/PM"
                                popperPlacement="bottom-start"
                                popperProps={{ strategy: 'fixed' }}
                              />


                              {errors && <span id="notificationdateError" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{errors?.scheduleddate}</span>}
                            </div>
                            <label id="uploadIconLabel" className="form_label mt-2 span-style">UPLOAD IMAGE(OPTIONAL)</label>
                            {formData?.logo?.length > 0 ? (
                              <div className="upload-zone input-group mt-2">
                                <div id="uploadIconPreview" className="upload-icon">
                                  <div id="uploadIconBlock" className="img_block add_img_block">
                                    <span id="removeIconBtn" className="material-icons-outlined thumbnail-cls-icon" onClick={handleRemove} onKeyDown={keyActivate(handleRemove)}>close</span>
                                    {formData?.logo?.startsWith("blob:") ? <img id="activeImg" src={formData?.logo} width={150} /> : <img id="activeImg" src={` ${image}${formData?.logo}`} width={150} />}
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div>
                                <input type="file" accept="image/*" className="d-none" id="uploadIcon" onChange={handleFileChange} />
                                <label htmlFor="uploadIcon" id="uploadIconBtn" className="stroke-button logo-width">
                                  <span className="material-icons">file_upload</span>
                                </label>

                              </div>
                            )}


                            {subValDashboard && subValDashboard.add && subValDashboard.add.display === true && <button id="savenotificationBtn" className={subValDashboard && subValDashboard.add && subValDashboard.add.enable === true ? "fill-btn save_continue mt-3 float-none" : "fill-btn save_continue mt-3 float-none pe-none"} onClick={handlePublishClick} disabled={btnLoader || !canPublish}>
                              {btnLoader && <img id="loadingIcon" src={`${image}${appname}/images/web/rotate_right.svg`} className="loading-icon" alt="Loading" />}
                              {formData?.promotionid ? "Update" : "Publish"}
                            </button>}
                            {errors?.templateVars && (
                              <div className="errormsg" style={{ fontWeight: 'bold', color: 'red', fontSize: '11px' }}>
                                {errors.templateVars}
                              </div>
                            )}

                          </div>
                        </div>

                        <div id="notificationsCol" className="col-md-9 ps-1">
                          {isLoading ? <Loader /> :
                            <div id="basicPlanRight" className="basic_plan">
                              <h4 id="notificationsTitle" className="form-title">ALERTS HISTORY</h4>
                              <div style={{ overflowX: 'auto', width: '100%' }}>
                              <DataTable
                                id="notificationsTable"
                                key={keyForRerender}
                                columns={columns}
                                keyField="_id"
                                data={data}
                                direction="auto"
                                highlightOnHover
                                fixedHeaderScrollHeight="300px"
                                pagination
                                responsive
                                persistTableHead
                                striped
                                defaultSortField="name"
                                noDataComponent={customNoRecords()}
                                paginationTotalRows={data?.length}
                                onChangeRowsPerPage={handlePerRowsChange}
                                onChangePage={handlePageChange}
                                paginationPerPage={rowsPerPage}
                                paginationDefaultPage={currentPageNew}
                                paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}
                                paginationComponentOptions={{
                                  rowsPerPageText: 'Per page:',
                                  rangeSeparatorText: 'of',
                                  noRowsPerPage: false,
                                  selectAllRowsItem: false,
                                  selectAllRowsItemText: 'All',
                                }}
                                progressPending={isLoading}
                                progressComponent={<TableLoader />}
                                customStyles={{
                                  table: {
                                    style: { minWidth: '660px' },
                                  },
                                }}
                              />
                              </div>
                            </div>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Modal className="new-set-modal" show={!!previewAlert} onHide={() => setPreviewAlert(null)} id="preview-modal" centered>
            <div className="modal-dialog modal-dialog-centered m-0 w-100">
              <div className="modal-content rounded-4" style={{ background: '#fff', overflow: 'hidden' }}>
                <div className="modal-header border-0 justify-content-end pb-0">
                  <button
                    className="close-btn"
                    onClick={() => setPreviewAlert(null)}
                    id="preview-modal-close-btn"
                    style={{ background: 'transparent', border: 'none', fontSize: '22px', cursor: 'pointer' }}
                  >
                    <span className="material-icons">close</span>
                  </button>
                </div>
                <div className="modal-body pt-0 pb-4 px-4">
                  {previewAlert && (
                    <>
                      <h5 className="fw-bold text-center mb-1" style={{ fontSize: '18px' }}>{previewAlert.title}</h5>
                      <p className="text-center text-muted mb-3" style={{ fontSize: '13px' }}>
                        Posted {moment(previewAlert.scheduleddate).fromNow()} &mdash; {moment(previewAlert.scheduleddate).format('MMM D, YYYY, h:mm A')}
                      </p>
                      {previewAlert.logo && (
                        <div className="text-center mb-3">
                          <img
                            src={`${image}${previewAlert.logo}`}
                            alt="Alert"
                            style={{ maxWidth: '100%', maxHeight: '180px', borderRadius: '8px', objectFit: 'cover' }}
                          />
                        </div>
                      )}
                      <p style={{ fontSize: '15px', color: '#222', margin: 0 }}>{previewAlert.description}</p>
                    </>
                  )}
                </div>
              </div>
            </div>
          </Modal>

          {/* Confirmation before anything is sent: the exact rendered message,
              the audience size, and when it goes out. */}
          <Modal className="new-set-modal" show={showConfirm} onHide={() => setShowConfirm(false)} id="confirm-send-modal" centered>
            <div className="modal-dialog modal-dialog-centered m-0 w-100">
              <div className="modal-content rounded-4" style={{ background: '#fff', overflow: 'hidden' }}>
                <div
                  className="modal-header border-0 pb-0 justify-content-between align-items-center"
                  style={isSafetyAlert ? { borderTop: '4px solid #d33' } : undefined}
                >
                  <h5 className="fw-bold mb-0" style={{ fontSize: '16px', color: isSafetyAlert ? '#d33' : '#222' }}>
                    {isSafetyAlert ? 'Confirm safety alert' : 'Confirm send'}
                  </h5>
                  <button
                    className="close-btn"
                    onClick={() => setShowConfirm(false)}
                    id="confirm-send-close-btn"
                    style={{ background: 'transparent', border: 'none', fontSize: '22px', cursor: 'pointer' }}
                  >
                    <span className="material-icons">close</span>
                  </button>
                </div>

                <div className="modal-body pt-2 pb-4 px-4">
                  {preview && (
                    <div className="border-style mb-3" style={{ padding: '10px 12px', borderRadius: '5px', background: '#f8f9fa' }}>
                      <div style={{ fontWeight: 600, fontSize: '13px', color: '#222' }}>{preview.title}</div>
                      <div style={{ fontSize: '12px', color: '#555', marginTop: '4px' }}>
                        {preview.body}
                        <span style={{ color: '#999' }}>{OPT_OUT_SUFFIX}</span>
                      </div>
                      <div style={{ fontSize: '10px', color: '#888', marginTop: '6px' }}>
                        {preview.smsLength}/{SMS_SEGMENT_LIMIT} characters. The opt-out line is added automatically.
                      </div>
                    </div>
                  )}

                  <div style={{ fontSize: '13px', color: '#333' }}>
                    <div className="mb-1">
                      This will send to <b>{recipientCount}</b> visitor{recipientCount === 1 ? '' : 's'}
                      {' '}across <b>{locationCount}</b> location{locationCount === 1 ? '' : 's'}.
                    </div>
                    <div className="mb-1">
                      Groups: {formData?.visitor || '-'}
                    </div>
                    <div>
                      Scheduled: <b>{formData?.scheduleddate
                        ? moment(formData.scheduleddate).format('MMM D, YYYY, h:mm A')
                        : '-'}</b>
                    </div>
                  </div>
                </div>

                <div className="modal-footer border-0 justify-content-center gap-3 pb-4">
                  <button className="stroke-btn-style" onClick={() => setShowConfirm(false)} id="confirm-send-cancel-btn">
                    Cancel
                  </button>
                  <button
                    className="fill-btn save_continue"
                    onClick={handleConfirmSend}
                    id="confirm-send-btn"
                    style={isSafetyAlert ? { background: '#d33', borderColor: '#d33' } : undefined}
                  >
                    Confirm send
                  </button>
                </div>
              </div>
            </div>
          </Modal>

          <Modal className="new-set-modal" show={isDelete} id="delete-modal">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content rounded-4" id="delete-modal-content">

                {/* Modal Header */}
                <div className="modal-header border-0 justify-content-center position-relative" id="delete-modal-header">
                  <button
                    className="close-btn"
                    onClick={handleClose}
                    id="delete-modal-close-btn"
                  >
                    <span className="material-icons">close</span>
                  </button>
                </div>

                {/* Modal Body */}
                <div className="modal-body text-center" id="delete-modal-body">
                  <img
                    src={`${image}${appname}/images/web/disco-ball.gif`}
                    alt="Delete Icon"
                    className=""
                    style={{ width: "100px", height: "100px" }}
                    id="delete-modal-icon"
                  />
                  <h3 className="modal-sm-heading" id="delete-modal-title">Delete</h3>
                  <p className="modal-text" id="delete-modal-message">
                    The changes cannot be undone.<br />
                    Do you want to delete?
                  </p>
                </div>

                {/* Modal Footer */}
                <div className="modal-footer border-0 justify-content-center gap-3 pb-4" id="delete-modal-footer">
                  <button
                    className="stroke-btn-style"
                    onClick={() => setIsDelete(false)}
                    id="delete-modal-no-btn"
                  >
                    No
                  </button>

                  <button
                    className="fill-btn save_continue"
                    onClick={handleDeleteAlert}
                    id="delete-modal-yes-btn"
                  >
                    {deleteLoader && (
                      <img
                        src={`${image}${appname}/images/web/rotate_right.svg`}
                        className="loading-icon"
                        alt="Loading"
                        id="delete-modal-loading-icon"
                      />
                    )}
                    Yes
                  </button>
                </div>

              </div>
            </div>
          </Modal>

          <SweetAlert
            id="tableErrorAlert"
            show={tableErrMsg}
            custom
            confirmBtnText="OK"
            confirmBtnBsStyle="primary"
            title={"Something went wrong. Please reload again."}
            onConfirm={() => setTableErrMsg(false)}
          />

          <SweetAlert
            id="fileSizeErrorAlert"
            show={fileSizeError}
            warning
            confirmBtnText="OK"
            confirmBtnBsStyle="danger"
            title={fileError}
            onConfirm={() => setFileSizeError(false)}
          />

          <SweetAlert
            id="genericAlert"
            show={showAlert}
            title={alertConfig.title}
            type={alertConfig.type}
            onConfirm={() => setShowAlert(false)}
          >
            {alertConfig.message}
          </SweetAlert>

          <Footer id="footerComponent" />

          <ToastContainer
            id="toastContainer-alert"
            position="bottom-center"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover={false}
            theme="light"
          />
        </div>
        {/* } */}




      </div>

    </>
  );
};

export default Notification;
